// React
import React from 'react';
import classNames from 'classnames';
// Styles
import useStyles from './OrderRejectionReasons.style';
// Components
import CustomClickableBox from '../common/boxes/custom-clickable-box';

const OrderRejectionReasons = ({
  classes,
  onClickReason,
  rejectionReasons,
  title,
}) => {
  const componentClasses = useStyles();

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div
        className={classNames(
          componentClasses.rejectionReasonsContainer,
          classes.rejectionReasonsContainer,
        )}
      >
        {rejectionReasons.map(reason => {
          return (
            <CustomClickableBox
              classes={{ root: componentClasses.rejectionReasonItem }}
              title={reason.description}
              key={reason.id}
              onClick={() => {
                onClickReason(reason);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

OrderRejectionReasons.defaultProps = {
  classes: {},
};

export default OrderRejectionReasons;
